<template>
  <div
    v-if="visible"
    class="step-item-main">
    <div class="item-left"></div>
    <!-- editing -->
    <div class="item-content">
      <div class="content-title">
          <div>
            <el-input
              v-model="form.name"
              size="mini"
              style="width:175px;"
              placeholder="组织名称">
            </el-input>
          </div>
          <div>
            <el-button :disabled="!save_button_state" @click="add" plain size="mini">保存</el-button>
            <el-button @click="cancel" plain size="mini" style="margin-left: 5px">取消</el-button>
          </div>
      </div>
      <div class="content-date">
        <el-date-picker
          style="width:175px;"
          v-model="form.validityPeriod"
          type="date"
          size="mini"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
    </div>

  </div>
</template>
<script>
import { addAssociation, allOnAssociation } from '@/api/'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      visible: this.isShow,
      form: {
        name: '',
        validityPeriod: ''
      },
      isHover: false
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow (val) {
      this.visible = val
    }
  },
  computed: {
    save_button_state () {
      return !!this.form.name && !!this.form.validityPeriod
    },
    ...mapState({
      search: 'search'
    })
  },
  methods: {
    async add () {
      try {
        const res = await addAssociation(this, this.form)
        if (res && Number.parseInt(res.ret) === 1) {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          allOnAssociation(this, this.search)
          this.cancel()
        } else {
          this.$message.error({
            message: res.msg
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    cancel () {
      this.visible = false
      this.$emit('addCancel')
      this.form = {
        name: '',
        validityPeriod: ''
      }
    }
  }
}
</script>
<style scoped>
.step-item-main {
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 42px;
  /* background: #F2F2F2; */
}
.item-left {
  width: 40px;
  border-right: 3px solid #BCE4F5;
  border-bottom: 1px solid #FFFFFF;
}
.item-content {
  flex-basis: 100%;
  border-bottom: 1px solid #FFFFFF;
  display: flex;
  flex-direction: column;
}
.content-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top:8px;
  height: 33px;

}
.content-date {
  margin-top:4px;
  margin-bottom: 8px;
}
</style>
